import { useEffect } from 'react';
import { withErrorBoundary } from 'react-error-boundary';
import type { TypeJsonLdDetailed } from 'types/autogen/contentful';

function JsonLd(props: TypeJsonLdDetailed) {
    const {
        fields: { json },
        sys: { id }
    } = props;

    // biome-ignore lint/correctness/useExhaustiveDependencies: Only needs to run on first render.
    useEffect(() => {
        // Remove the existing script if it exists
        const existingScript = document.getElementById(id);
        if (existingScript) {
            document.head.removeChild(existingScript);
        }

        // Create a new script element
        const scriptElement = document.createElement('script');
        scriptElement.type = 'application/ld+json';
        scriptElement.id = id;
        scriptElement.innerHTML = JSON.stringify(json);

        // Append the script to the head
        document.head.appendChild(scriptElement);

        // Cleanup function to remove the script when the component unmounts
        return () => {
            const scriptToRemove = document.getElementById(id);
            if (scriptToRemove) {
                document.head.removeChild(scriptToRemove);
            }
        };
    }, []);

    return null;
}

export default withErrorBoundary(JsonLd, {
    fallback: null,
    onError(error, info) {
        console.error(error, info);
    }
});
